import React, { useRef, useEffect } from 'react';
import { getTheme, useThemeMode } from '../theme';
import L from 'leaflet';

export function DraggablePositionMap({lat,lng,onChange}:{lat:string;lng:string;onChange:(lat:string,lng:string)=>void}){
  const {mode}=useThemeMode();const T=getTheme(mode);
  const mapRef=useRef<HTMLDivElement>(null);
  const mapInst=useRef<L.Map|null>(null);
  const markerRef=useRef<L.Marker|null>(null);
  const initLat=parseFloat(lat)||63.0;
  const initLng=parseFloat(lng)||15.0;
  const zoom=parseFloat(lat)?12:5;
  useEffect(()=>{
    if(!mapRef.current||mapInst.current)return;
    const map=L.map(mapRef.current,{zoomControl:true}).setView([initLat,initLng],zoom);
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',{attribution:'© OSM',maxZoom:19}).addTo(map);
    const icon=L.divIcon({className:'',html:`<div style="width:20px;height:20px;background:#EE8F09;border:3px solid #fff;border-radius:50%;box-shadow:0 2px 6px rgba(0,0,0,0.4);cursor:grab"></div>`,iconSize:[20,20],iconAnchor:[10,10]});
    const marker=L.marker([initLat,initLng],{icon,draggable:true}).addTo(map);
    marker.on('dragend',()=>{
      const p=marker.getLatLng();
      onChange(p.lat.toFixed(6),p.lng.toFixed(6));
    });
    map.on('click',(e:L.LeafletMouseEvent)=>{
      marker.setLatLng(e.latlng);
      onChange(e.latlng.lat.toFixed(6),e.latlng.lng.toFixed(6));
    });
    markerRef.current=marker;
    mapInst.current=map;
    setTimeout(()=>map.invalidateSize(),100);
    return()=>{map.remove();mapInst.current=null;markerRef.current=null;};
  },[]);
  // sync external lat/lng if changed programmatically
  useEffect(()=>{
    if(!markerRef.current||!mapInst.current)return;
    const la=parseFloat(lat),lo=parseFloat(lng);
    if(!isNaN(la)&&!isNaN(lo)){
      markerRef.current.setLatLng([la,lo]);
    }
  },[lat,lng]);
  const curLat=parseFloat(lat),curLng=parseFloat(lng);
  const hasPos=!isNaN(curLat)&&!isNaN(curLng)&&(curLat!==0||curLng!==0);
  return(
    <div>
      <div ref={mapRef} style={{height:220,borderRadius:8,border:`1px solid ${T.border}`,overflow:'hidden',marginTop:4}}/>
      <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginTop:4}}>
        <span style={{fontSize:11,color:T.textMuted}}>Klicka på kartan eller dra pinnen för att sätta position</span>
        {hasPos&&<span style={{fontSize:11,color:T.amber,fontWeight:600}}>{curLat.toFixed(5)}, {curLng.toFixed(5)}</span>}
      </div>
    </div>
  );
}
